export enum Period {
  All = 0,
  LastYear = 1,
  LastMonth = 2,
  LastWeek = 3
}
